import { client } from '../../../../../App';
import { GET_AUTOMATED_COLUMNS } from '../../../../../queries/widgets';
import { normalizeAutomatedColumnsInput } from '../../../../../utils/normalizeAutomatedColumnsInput';
import { isSquadDynamicCell } from './squadFondsdatenDynamic';
import {
  DYNAMIC_SECTION_HEADER_KEYS,
  formatSquadHeaderDatum,
  type SquadSectionHeaderKey,
} from './sectionHeaderPlaceholders';
import { formatSquadUntil } from './squadSrriwert';

/**
 * Fetch live values for dynamic SQUAD section headers (e.g. cixon_chart.datum).
 * Returns a map keyed by section-header key → resolved display string.
 */
export async function fetchSquadSectionHeaderDynamicValues(
  headers: Record<string, unknown> | undefined | null,
  isin: string,
  until?: string | null,
): Promise<Map<string, string>> {
  const out = new Map<string, string>();
  const fundIsin = String(isin || '').trim().toUpperCase();
  if (!fundIsin || !headers) return out;

  const untilIso = formatSquadUntil(until) || undefined;
  const entries: Array<{ key: SquadSectionHeaderKey; config: any }> = [];
  DYNAMIC_SECTION_HEADER_KEYS.forEach((key) => {
    const raw = headers[key];
    if (isSquadDynamicCell(raw) && raw.fields?.length) {
      entries.push({ key, config: raw });
    }
  });
  if (!entries.length) return out;

  try {
    const res = await client.query({
      query: GET_AUTOMATED_COLUMNS,
      variables: {
        param: {
          data: normalizeAutomatedColumnsInput([entries.map((e) => e.config)]),
          isin: fundIsin,
          until: untilIso,
        },
      },
      fetchPolicy: 'network-only',
    });
    const row = res?.data?.getAutomatedColumns?.[0];
    if (!Array.isArray(row)) return out;
    entries.forEach((entry, i) => {
      const val = row[i];
      if (val == null || String(val).trim() === '') return;
      const text = String(val).trim();
      out.set(
        entry.key,
        text.replace(/\b(\d{4}-\d{2}-\d{2})\b/g, (iso) => formatSquadHeaderDatum(iso) || iso),
      );
    });
  } catch {
    // preview/PDF keep as-of fallback
  }
  return out;
}
